// extracted by mini-css-extract-plugin
module.exports = {"root":"y_bJ","filled":"y_cn","input-area":"y_cp","inputArea":"y_cp","label":"y_b8"};